/* Korean Member signup surface: Ghost remains the identity and newsletter authority. */
(function () {
  const surface = document.querySelector('[data-member-signup]');

  if (!surface) {
    return;
  }

  const form = surface.querySelector('.member-signup-form');
  const nameInput = form && form.querySelector('input[name="name"]');
  const emailInput = form && form.querySelector('input[name="email"]');
  const feedback = surface.querySelector('[data-member-signup-feedback]');
  const submitButton = form && form.querySelector('.member-signup-submit');

  if (!form || !nameInput || !emailInput || !feedback || !submitButton) {
    return;
  }

  const setFeedback = (message, isError) => {
    feedback.textContent = message;
    feedback.classList.toggle('billing-error', Boolean(isError));
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    nameInput.value = nameInput.value.trim();
    emailInput.value = emailInput.value.trim();

    if (!emailInput.checkValidity()) {
      setFeedback('올바른 이메일 주소를 입력해 주세요.', true);
      emailInput.focus();
      return;
    }

    submitButton.disabled = true;
    setFeedback('', false);

    try {
      const integrityResponse = await fetch('/members/api/integrity-token/', {
        method: 'GET',
        credentials: 'same-origin'
      });

      if (!integrityResponse.ok) {
        throw new Error('integrity_request_failed');
      }

      const integrityToken = await integrityResponse.text();
      const newsletters = Array.from(form.querySelectorAll('input[type="checkbox"][data-members-newsletter]:checked'))
        .map((input) => ({name: input.value}));
      const signupRequest = {
        email: emailInput.value,
        emailType: 'signup',
        newsletters,
        integrityToken
      };
      if (nameInput.value) signupRequest.name = nameInput.value;

      const response = await fetch('/members/api/send-magic-link/', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(signupRequest)
      });

      if (!response.ok) {
        if (response.status === 429) {
          setFeedback('요청이 많습니다. 잠시 후 다시 시도해 주세요.', true);
        } else {
          setFeedback('가입 요청을 완료하지 못했습니다. 이메일 주소를 확인한 뒤 다시 시도해 주세요.', true);
        }
        return;
      }

      setFeedback('인증 이메일을 확인해 주세요. 이메일의 링크를 열면 가입이 완료됩니다.', false);
    } catch (error) {
      setFeedback('가입 요청을 보낼 수 없습니다. 잠시 후 다시 시도해 주세요.', true);
    } finally {
      submitButton.disabled = false;
    }
  });
})();
